<template>
  <nav class="gnav">
    <ul>
      <li>
        <router-link :to="{name: 'ComposePot'}" class="fx_ctr">
          <span class="icon fx_ctr stong"><font-awesome-icon icon="pen-square" /></span>
          <span class="txt">Create</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'Home'}" class="fx_ctr" @click.native="toggleSpSlide(false)">
          <span class="icon fx_ctr"><font-awesome-icon icon="list-ul" /></span>
          <span class="txt">My Pots</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'Archived'}" class="fx_ctr" @click.native="toggleSpSlide(false)">
          <span class="icon fx_ctr"><font-awesome-icon icon="archive" /></span>
          <span class="txt">Archived</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'ToolsTop'}" class="fx_ctr" @click.native="toggleSpSlide(false)">
          <span class="icon fx_ctr"><font-awesome-icon icon="tools" /></span>
          <span class="txt">Tools</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'Home'}" class="fx_ctr">
          <span class="icon fx_ctr"><font-awesome-icon icon="heart" /></span>
          <span class="txt">Favorite</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'Home'}" class="fx_ctr">
          <span class="icon fx_ctr notice"><font-awesome-icon icon="hashtag" /></span>
          <span class="txt">Tags</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'Home'}" class="fx_ctr">
          <span class="icon fx_ctr notice"><font-awesome-icon icon="search" /></span>
          <span class="txt">Explore</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'GlobalMenu',
  methods: {
    ...mapActions([
      "toggleSpSlide"
    ])
  }
}
</script>
